// This file is automatically generated. Do not edit manually.

export const locales = [
  "default",
  "fr",
  "nl",
  "de"
] as const;

export type Locale = typeof locales[number];
